import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { MainLayout } from 'layout';
import {
  InfoPage,
  ApplicationWagonPage,
  ApplicationSupplyPage,
  SupplyPrintPage,
  ExportSettingsPage,
  ArchiveExecutionPage,
  UsersPage,
  Logs,
  NotificationsPage,
  ContactsPage,
  ContractsPage,
  ConsigneesPage,
  QueuePage,
  ProductionCapacities,
  ProductsPage,
  StationsPage,
  DirectionsPage,
  ConsigneeCatalogPage,
} from 'pages';

const AdminRoutes = () => (
  <MainLayout>
    <Switch>
      <Route exact path="/profile" component={InfoPage} />
      <Route exact path="/profile/:userId" component={InfoPage} />
      <Route exact path="/profile/:userId/contacts" component={ContactsPage} />
      <Route exact path="/profile/:userId/contracts" component={ContractsPage} />
      <Route exact path="/profile/:userId/consignees" component={ConsigneesPage} />
      <Route
        exact
        path="/profile/:userId/applications"
        render={({ match: { params: { userId } } }) => <Redirect to={`/profile/${userId}/applications/supply`} />}
      />
      <Route exact path="/profile/:userId/applications/wagon" component={ApplicationWagonPage} />
      <Route exact path="/profile/:userId/applications/supply" component={ApplicationSupplyPage} />
      <Route exact path="/profile/:userId/applications/supply/archive" component={ApplicationSupplyPage} />
      <Route
        exact
        path="/applications"
        render={() => <Redirect to="/applications/supply" />}
      />
      <Route exact path="/applications/wagon" component={ApplicationWagonPage} />
      <Route exact path="/applications/supply" component={ApplicationSupplyPage} />
      <Route exact path="/applications/supply/archive" component={ApplicationSupplyPage} />
      <Route exact path="/applications/supply/print/:id" component={SupplyPrintPage} />
      <Route exact path="/users" component={UsersPage} />
      <Route exact path="/queue" component={QueuePage} />
      <Route exact path="/export-settings" component={ExportSettingsPage} />
      <Route exact path="/archive-execution" component={ArchiveExecutionPage} />
      <Route exact path="/notifications" component={NotificationsPage} />
      <Route exact path="/production-capacities" component={ProductionCapacities} />
      <Route exact path="/logs-list" component={Logs} />
      <Route exact path="/products" component={ProductsPage} />
      <Route exact path="/stations" component={StationsPage} />
      <Route exact path="/directions" component={DirectionsPage} />
      <Route exact path="/consignees/catalog" component={ConsigneeCatalogPage} />
      <Redirect to="/queue" />
    </Switch>
  </MainLayout>
);

export default AdminRoutes;
